import { ThemeMultiplierLandAnimationBehaviour } from "behaviours/theme-multiplier-land-animation-behaviour";
import { TintDimSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/tint-dim-symbol-behaviour";
import { SymbolSubcomponent } from "slotworks/components/matrix/symbol/symbol-subcomponent";

/**
 * ThemeTintDimSymbolBehaviour is a class that extends TintDimSymbolBehaviour.
 *
 * It is responsible for managing and controlling the dimming of symbols in different states. Specifically, this class extension will handle
 * the dimming of non-winning symbols that have the multiplier behavior attached to them, interrupting the multiplier's 'land' animation if necessary
 * when the presentation enters the dimming phase. Otherwise, the multiplier symbol will continue animating, and thus not be dimmed, while all other symbols
 * around it are dimmed.
 */
export class ThemeTintMultiplierSymbolBehaviour extends TintDimSymbolBehaviour {

    public behaviourName: string = "ThemeTintDim";

    constructor(symbol: SymbolSubcomponent, protected dimTint: number = 0x333333) {
        super(symbol);
    }

    // We need check to see if the symbol is animating a land animation, so we can turn the animation off in the event of a dim.
    /**
     * This method is responsible for the highlightDim behavior. This specific override will call the resolveUnfinishedAnimation()
     * method of the multiplier symbol when the game enters the dimming phase of the presentation. This prevents multiplier symbols
     * from animating when all of the other non winning symbols around them are dimmed.
     * @returns {Contract<void>} - The animation contract for this symbol. Since we are dimming the symbol, this actually just returns an empty animation contract since
     *                             there is nothing to animate.
     */
    public override highlightDim() {
        let symbolAnimateBehavior = this.symbol.getBehaviourByName("ThemeMultiplierLandAnimation") as ThemeMultiplierLandAnimationBehaviour;
        symbolAnimateBehavior?.resolveUnfinishedAnimation();
        return super.highlightDim();
    }
}
